module.exports = __webpack_public_path__ + "static/media/geofenceMarkerCallout_Yay.21e0436a.svg";